// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__lwiXc","red":"heading_red__HxTLM","center":"heading_center__kkblF"};